import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Heading, Grid } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import GuardianStudentOverview from '../guardian/GuardianStudentOverview';
import GuardianOverview from '../guardian/GuardianOverview';
import LoadingIndicator from '../shared/LoadingIndicator';
import { reportService } from '../../services/guardian/reportService';
import GuardianIntroduction from '../guardian/GuardianIntroduction';
import GuardianStudentOverviewSkeleton from '../skeletons/GuardianStudentOverviewSkeleton';
import { useDispatch } from 'react-redux';
import { set } from 'lodash';

const GuardianDashboard = () => {
  const user = useSelector((state) => state.user.details);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState(null);
  const [studentReports, setStudentReports] = useState([]);
  const guardian = useSelector((state) => state.guardian);
  console.log('guardian:', guardian);


  useEffect(() => {
    if (guardian.students.length > 0) {
      getSummary();
    }
    setLoading(false);
  }, [guardian.students]);

  const getSummary = async () => {
    try {
      setLoading(true);
      const data = await reportService.getCurrentReport(guardian.details.id);
      console.log('guardian report data', data);
      if (data.error) {
        setError(data.error);
      } else {
        console.log('student reports', data);
        setStudentReports(data);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Grid>
      <Box width="100%" maxWidth="1080px">
        <LoadingIndicator />
      </Box>
      <Box width="100%" maxWidth="1080px">
        <GuardianStudentOverviewSkeleton />
      </Box>
    </Grid>
  };

  if(guardian.students.length === 0){
    return <GuardianIntroduction />
  }

  return (
    <Box width="100%" maxWidth="1080px">
      <Grid columns="4" gap="4">
        <Box gridColumn={{ initial: "span 4", md: "span 2" }}>
            <GuardianOverview reports={studentReports} />
        </Box> 
        <Box gridColumn={{ initial: "span 4", md: "span 2" }}>
            <Flex direction="column" gap="4">
              <GuardianStudentOverview reports={studentReports} />
            </Flex>
        </Box>
      </Grid>
    </Box>
  );
};

export default GuardianDashboard;
